import script from "./RecommendView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendView.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendView.vue?vue&type=style&index=0&id=6559fd74&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6559fd74"]])

export default __exports__